import { useEffect, useState } from "react";

import FirebaseService from "../actions/firebase/FirebaseActions";
import Registration from "../models/registration/Registration";
import { FirebaseSnapshotMapper } from "../actions/firebase/FirebaseSnapshotMapper";

// waitlist entries share the shape of registrations
export const useWaitlist = (userId: string): [Registration[], boolean, boolean?] => {
  const [entries, setEntries] = useState<Registration[]>([]);
  const [error, setError] = useState<boolean>();
  const [isLoading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    setLoading(true);

    return FirebaseService.streamWaitlist(userId, {
      next: (querySnapshot) => {
        setEntries(FirebaseSnapshotMapper.toRegistrations(querySnapshot));
        setLoading(false);
      },
      error: () => {
        setError(true);
        setLoading(false);
      }
    });
  }, [userId]);

  return [entries, isLoading, error];
};
